import styled from "@emotion/styled"
import { PText } from "@porsche-design-system/components-react"
import { colorContrastLow, spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import type { StandardEquipmentItem } from "@slfinrtl/ui-bff-routes"
import { SpecialEquipmentItem } from "../special/SpecialEquipmentItem"

interface SimpleEquipmentItemProps {
	item: StandardEquipmentItem
	onClick?: (item: StandardEquipmentItem) => void
}

export const SimpleEquipmentItem = ({ item, onClick }: SimpleEquipmentItemProps) => {
	return (
		<Wrapper>
			<SimpleEquipmentRow>
				<PText dangerouslySetInnerHTML={{ __html: item.overwrittenBy ? `<s>${item.name}</s>` : item.name }} />
				{item.optionCode && (
					<PText color="contrast-medium" size="xs">
						{item.optionCode}
					</PText>
				)}
			</SimpleEquipmentRow>
			{item.overwrittenBy && <SpecialEquipmentItem item={item.overwrittenBy} onClick={onClick} />}
		</Wrapper>
	)
}

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: ${spacingStaticSm} 0;
	border-bottom: 1px solid ${colorContrastLow};
`

const SimpleEquipmentRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: ${spacingStaticSm};
`
